import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const W = 1080;
const H = 1080;

// 📊 POG WRAPPED — monthly recap flex card.
export const sharePogWrapped = async () => {
  let d;
  try {
    d = (await axios.get(`${API}/wrapped`, { withCredentials: true })).data;
  } catch (e) {
    toast.error("Couldn't load your Wrapped — try again!");
    return;
  }
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#0F172A";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "#38bdf8";
  ctx.lineWidth = 14;
  ctx.strokeRect(28, 28, W - 56, H - 56);
  ctx.textAlign = "center";
  ctx.fillStyle = "#38bdf8";
  ctx.font = "800 40px Arial";
  ctx.fillText("A I R . P O G", W / 2, 130);
  ctx.fillStyle = "#ffffff";
  ctx.font = "900 76px Arial";
  ctx.fillText("📊 POG WRAPPED", W / 2, 232);
  ctx.fillStyle = "#e879f9";
  ctx.font = "800 44px Arial";
  ctx.fillText(d.month, W / 2, 295);
  ctx.fillStyle = "#fbbf24";
  ctx.font = "900 120px Arial";
  ctx.fillText(`${d.points.toLocaleString()} PTS`, W / 2, 440);
  ctx.fillStyle = "#94a3b8";
  ctx.font = "700 38px Arial";
  ctx.fillText(`across ${d.earns} POG strikes this month`, W / 2, 495);
  ctx.fillStyle = "#e2e8f0";
  ctx.font = "800 52px Arial";
  ctx.fillText(`${d.tier.emoji} ${d.tier.name} · ${d.level.id} ${d.level.name}`, W / 2, 600);
  ctx.font = "800 46px Arial";
  ctx.fillStyle = "#34d399";
  ctx.fillText(`🎖 ${d.badges_earned}/${d.badges_total} badges · 🤝 crew of ${d.crew}`, W / 2, 680);
  if (d.biggest) {
    ctx.fillStyle = "#f59e0b";
    ctx.font = "800 40px Arial";
    ctx.fillText(`💥 Biggest strike: +${d.biggest.amount} pts`, W / 2, 770);
  }
  ctx.fillStyle = "#94a3b8";
  ctx.font = "700 40px Arial";
  ctx.fillText("Get yours at airpog.com 🎯", W / 2, H - 100);

  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  if (!blob) return;
  const caption = `📊 MY POG WRAPPED — ${d.month}: ${d.points.toLocaleString()} pts, ${d.tier.emoji} ${d.tier.name}, ${d.badges_earned}/${d.badges_total} badges! Just POG it 👉 airpog.com`;
  const file = new File([blob], "pog-wrapped.png", { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "MY POG WRAPPED", text: caption });
      return;
    } catch (e) {
      if (e.name === "AbortError") return;
    }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "pog-wrapped.png";
  a.click();
  URL.revokeObjectURL(a.href);
  try { await navigator.clipboard.writeText(caption); } catch (e) { /* ignore */ }
  toast.success("Wrapped card downloaded + caption copied — flex your month! 📊");
};
